<template>

 <mw-dialog  size="mini_mini" :footerButton="btns" ref="dialog" :close-on-click-modal="false">
        <div style="margin-top:20px">

           <el-checkbox-group  v-model="checkList" >
           
              <el-checkbox 
             
              v-for="item in list"
               :key="item.id"  :label="item.id"
                           style="display: block;margin-left: 80px;height: 30px;line-height:30px;font-size: 16px;font-weight: normal"
              >{{item.name}} <span></span></el-checkbox>
            </el-checkbox-group>

        </div>
       
  </mw-dialog>

</template>
<script>
    export default {
        data() {
            return {
              checkList : [],
              checked :[],
              user: [],
              btns: [{
              label: '全选',
              func: this.selectAll
              },{
              label: '反选',
              func: this.selectSome,
              type: 'default'
              },{
              label: '取消',
              type: 'default',
              func: this.cancelLevel
              },{
              label: '确定',
              func: this.confirmLevel
              }],   
              list: [{
                'id': 1,
                'name': '第一级用户'
              }, {'id': 2, 'name': '第二级用户'},
                {'id': 3, 'name': '第三级用户'},
                {'id': 4, 'name': '第四级用户'},
                {'id': 5, 'name': '领导级'},
                {'id': 6, 'name': '部门级'}
              ],
            }
        },
      methods:{
        show(){
          this.mwRef('dialog').show();
        },
        selectAll(){
          this.checkList = [],
            this.list.forEach(user =>{
              this.checkList.push(user.id);
            })
        },

        selectSome(){
          if(this.checkList.length == 0){
            this.list.forEach(user =>{
              this.checkList.push(user.id);
            })
          }
          else{

           var a = [];
            this.list.forEach(user =>{
              a.push(user.id);
            });
            for(let t = 0 ; t<this.checkList.length;t++){
              for(let i =0;i<this.list.length;i++){
                if (this.checkList[t] === this.list[i].id) {
                  delete a[i];
                  break;
                }
              }
            }
            this.checkList = a;
          }


        },

        cancelLevel(){
          this.mwRef('dialog').hide();
        },
       confirmLevel(){
         this.user = [];
         for(let i = 0;i<this.checkList.length;i++){
             this.list.forEach( r =>{
               if(this.checkList[i] === r.id){
                 this.user.push({id:this.checkList[i],name: r.name}) ;
               }
             })    
         }
         this.mwRef('dialog').hide();
         this.$emit("confirm",this.user);
       }

      }
    }
</script>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/infothirdLevel.vue